module.exports = __webpack_public_path__ + "img/highlights2.617f0741.png";